import useSWR from 'swr';

import { CollateralHelpers } from 'helpers/CollateralHelpers';
import { CompanyHelpers } from 'helpers/CompanyHelpers';

import { useCompanyProfile } from 'hooks/use-company-profile';
import { useComponent } from 'hooks/use-component';
import { CollateralService } from 'services/CollateralService';

const useCollateralItem = (collateralId: string) => {
    const { data: collateral, ...swr } = useSWR(CollateralHelpers.swr.item(collateralId), () =>
        CollateralService.get(collateralId),
    );
    const { component: product } = useComponent(collateral?.company ? null : collateral?.product, { depth: 0 });
    const { company } = useCompanyProfile(collateral?.company ?? product?.manufacturer);

    const href = collateral && company && CompanyHelpers.urls.collateralItem(company.slug ?? company.id, collateral.id);

    return { ...swr, collateral, href };
};

export { useCollateralItem };
